import { Button } from '@/components/ui/button'

type SlamContextMenuProps = {
  x: number
  y: number
  markerId: string | null
  hasName: boolean
  isConfirmingAddNew: boolean
  onAdd: () => void
  onMoveRobot?: () => void
  onGoHome?: () => void
}

export function SlamContextMenu({
  x,
  y,
  markerId,
  hasName,
  isConfirmingAddNew,
  onAdd,
  onMoveRobot,
  onGoHome,
}: SlamContextMenuProps) {
  return (
    <div
      role="presentation"
      style={{ left: x, top: y }}
      className="absolute z-50 w-[152px] overflow-hidden bg-white shadow-2xl border border-gray-100 flex flex-col rounded-xl"
      onClick={(e) => e.stopPropagation()}
      onKeyDown={(e) => e.stopPropagation()}
    >
      {markerId !== 'home' && (!markerId || !hasName) && (
        <Button
          variant="ghost"
          disabled={isConfirmingAddNew}
          onClick={onAdd}
          className="w-full justify-start px-6 py-5 text-[14px] font-semibold hover:!text-[#CE7A58] hover:!bg-[#FFF7F3]"
        >
          {isConfirmingAddNew ? 'Đang thêm...' : 'Thêm mới'}
        </Button>
      )}
      <Button
        variant="ghost"
        disabled={!onMoveRobot}
        onClick={onMoveRobot}
        className="w-full justify-start px-6 py-5 text-[14px] font-medium hover:!text-[#CE7A58] hover:!bg-[#FFF7F3] border-b border-gray-50"
      >
        Di chuyển ngay
      </Button>
      <Button
        variant="ghost"
        disabled={!onGoHome}
        onClick={onGoHome}
        className="w-full justify-start px-6 py-5 text-[14px] font-medium hover:!text-[#CE7A58] hover:!bg-[#FFF7F3]"
      >
        Về trụ sạc
      </Button>
    </div>
  )
}
